<template>
  <v-row dense>
    <v-col cols="12" xl="12">
      <v-card
        elevation="0"
        class="all-trade-tab rounded-0 mb-0 px-3"
        :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'"
      >
        <div class="mt-0 pt-8 pb-3">
          <div class="titleName d-flex align-center mb-8">
            <v-img
              class="mr-2"
              max-width="17"
              src="@/assets/Dashboard/bar.svg"
            ></v-img>
            <span>Level & Commissions</span>
          </div>
        </div>
        <v-tabs
          :background-color="
            $vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'
          "
          class="pb-0"
        >
          <v-tab class="ml-0"> All Level </v-tab>
          <v-tab> Level 1 </v-tab>
          <v-tab> Level 2 </v-tab>
          <v-tab> Level 3 </v-tab>
         
          <v-tab-item>
            <v-card flat>
              <LevelAllTab></LevelAllTab>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <LevelOneTab></LevelOneTab>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <LevelTwoTab></LevelTwoTab>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <LevelThreeTab></LevelThreeTab>
            </v-card>
          </v-tab-item>
          
          
          
        </v-tabs>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

import LevelAllTab from "@/components/TradeMaster/LevelAllTab.vue";
import LevelOneTab from "@/components/TradeMaster/LevelOneTab.vue";
import LevelThreeTab from "@/components/TradeMaster/LevelThreeTab.vue";
import LevelTwoTab from "@/components/TradeMaster/LevelTwoTab.vue";


export default {
  components: {
    LevelAllTab,
    LevelOneTab,
    LevelTwoTab,
    LevelThreeTab,
  },
};
</script>
